/* Javascript for the mobile toggle button */
$('.ajax-navbar-mobile-toggle').click(function () {
  $('.ajax-navbar-container').toggleClass('open');
});
